module.exports = __webpack_public_path__ + "static/media/adellesans-regular-webfont.0a86f4cd.ttf";